import { render, staticRenderFns } from "./DemoI18n.vue?vue&type=template&id=9339d8f8&"
import script from "./DemoI18n.vue?vue&type=script&lang=js&"
export * from "./DemoI18n.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DemoI18n.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "DemoI18n.vue"
export default component.exports